import React from 'react';
import { Col, Row } from 'react-bootstrap';

import cx from 'classnames';
import getColourPropsByColourSchemaAndCampaignColor from 'utils/getColourPropsByColourSchemaAndCampaignColor';

import DynamicHeadingLine from 'components/DynamicHeadingLine/DynamicHeadingLine';
import HorizontalRightImageContent from 'components/HorizontalRightImageContent/HorizontalRightImageContent';
import LinkButtonRow from 'components/LinkButtonRow/LinkButtonRow';
import { ICampaignContent } from 'models/campaignContent';

interface IProps {
  campaignContent: ICampaignContent;
  colour: string;
}
const HorizontalRightImageCampaignContent: React.FC<IProps> = ({
  campaignContent,
  colour,
}) => {
  const { backgroundColor, btnVariant, headingColor, textColorClass } =
    getColourPropsByColourSchemaAndCampaignColor(
      colour,
      campaignContent.colour_schema?.name,
    );

  return (
    <>
      {!!campaignContent.heading && (
        <Row className="g-0">
          <Col sm={12} lg={{ span: 8, offset: 1 }}>
            <div className="full-width-title-container">
              <h1 className="text-left" data-content="campaign_content_heading">
                {campaignContent.heading}
              </h1>
              <DynamicHeadingLine colour={colour} />
            </div>
          </Col>
        </Row>
      )}
      <HorizontalRightImageContent
        style={{ backgroundColor }}
        imageUrl={campaignContent?.content_media?.url}
        imageAlt={campaignContent.content_media_alt}
        className={cx(
          'horizontal-right-image-campaign my-auto w-100 flex-grow-1',
          textColorClass,
        )}
      >
        {!!campaignContent.sub_heading && (
          <>
            <h2
              data-content="campaign_content_sub_heading"
              className="text-bold mt-3"
            >
              {campaignContent.sub_heading}
            </h2>
            <DynamicHeadingLine colour={headingColor} width="50%" marginSmall />
          </>
        )}

        {!!campaignContent.content_brief && !campaignContent.sub_heading && (
          <div className="d-flex flex-column justify-content-center h-100">
            <div
              data-content="campaign_content_content_brief"
              dangerouslySetInnerHTML={{
                __html: campaignContent.content_brief,
              }}
            />
          </div>
        )}

        {!!campaignContent.content_brief && campaignContent.sub_heading && (
          <div
            data-content="campaign_content_content_brief"
            dangerouslySetInnerHTML={{
              __html: campaignContent.content_brief,
            }}
          />
        )}

        <LinkButtonRow
          btnProps={{ variant: btnVariant }}
          links={campaignContent.links || []}
        />
      </HorizontalRightImageContent>
    </>
  );
};

export default HorizontalRightImageCampaignContent;
